import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { useLoading } from "../../../context/LoadingContext";
import { Card, Container, Button, Form, Row, Col } from "react-bootstrap";
import InputSearch from "../../../components/InputSearhComponent";
import { initializeSetOption } from "../../../utils/InitializeSetDefault";
import TableForm2s from "../../../components/TableFormScrb";
import ConfirmModal from "../../../components/ConfirmModal";
import SearchFilter from "../../../components/SearchFilter";
import { useNavigate, useLocation, useParams } from "react-router-dom";
import { formatDate } from "../../../commons/FormatValue";
import { addEditServiceRequest, getServiceRequest } from "../../../commons/ServiceRequest";
import TechExpenseService from "../../../services/techexpenses.service";
import { useAlert } from "../../../context/AlertContext";

export default function EditExpense() {
  const { setLoading } = useLoading();
  const navigate = useNavigate();
  const { state } = useLocation();
  const { showAlert } = useAlert();
  useEffect(() => {
    // setTableData([state])
    getServiceRequest({
      showAlert,
      setLoading,
      serviceRequest: TechExpenseService.getTechExpense(state?.Id),
      callback: (res) => {
        setTableData([{ ...res.data, date: formatDate(res.data.expenses_date) }])
      }
    });
  }, []);

  const [tableData, setTableData] = useState([]);
  const [JobType, setJobType] = useState([]);
  const [SeqNo, setSeqNo] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [dataModal, setDataModal] = useState();

  const searchInput = [
    {
      name: "date",
      label: "วันที่เข้างาน",
      classNames: { label: "mb-3" },
      type: "text",
      size: 3,
      disabled: true,
      type: 'text',
      value: formatDate(state?.job_actual_date)
    },
    {
      name: "seq_no",
      label: "เลขที่ใบสั่งาน",
      classNames: { label: "mb-3" },
      size: 3,
      filterBy: ["seq_no"],
      options: initializeSetOption({
        key: "seq_no",
        label: "seq_no",
        dataset: SeqNo
      }),
      disabled: true,
      type: 'text',
      value: state?.seq_no
    },
    {
      name: "job_type_id",
      label: "ประเภทงาน",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      type: "text",
      value: state?.job_type_name
    },
    {
      name: "no",
      label: "ครั้งที่/งานย่อย",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      type: "text",
      value: state.no
    },
    {
      name: "cus_code",
      label: "รหัสลูกค้า/สาขา",
      classNames: { label: "mb-3" },
      size: 3,
      disabled: true,
      type: "text",
      value: state.cus_code
    },
    {
      name: "num_branch",
      label: "เลขทีสาขา",
      classNames: { label: "mb-3" },
      size: 2,
      disabled: true,
      type: "text",
      value: state.num_branch
    },
    {
      name: "cus_name",
      label: "ชื่อสาขา",
      classNames: { label: "mb-3" },
      size: 5,
      disabled: true,
      type: "text",
      value: state.cus_name
    },
  ];

  const columns = [
    {
      name: "date",
      label: "วันที่บันทึก",
      readOnly: true
    },
    {
      name: "expenses_desc",
      label: "รายละเอียดอุปกรณ์/อะไหล่",
    },
    {
      name: "expenses_qty",
      label: "จำนวน",
      width: "80px",
      min: 0,
      type: 'number'
    },
    {
      name: "expenses_unit",
      label: "หน่วย",
      width: "80px"
    },
    {
      name: "expenses_price",
      label: "ราคา",
      width: "80px",
      min: 0,
      type: 'number'
    },
    {
      name: "expenses_total_price",
      label: "จำนวนเงิน",
      readOnly: true
    },
    {
      name: "expenses_price_unit",
      label: "สกุลเงิน",
    },
    {
      name: "remark",
      label: "หมายเหตุ",
    },
  ];

  const handleSubmit = async (event, { dataCallback, showCallback }) => {
    event.preventDefault();
    setShowModal(showCallback);

    if (dataCallback) {
      delete dataCallback.date
      try {
        addEditServiceRequest({
          showAlert,
          setLoading,
          serviceRequest: TechExpenseService.editTechExpense(state?.Id, dataCallback),
          navigated: (navi) =>
            navigate('/service_work/expenses')
        });
      } catch (error) {
        console.error(error);
      }
    }
  };

  return (
    <>
      <Helmet>
        <title>แก้ไขค่าใช้จ่ายระหว่างทำงาน</title>
        <meta name="description" content="Expenses During Work Page" />
      </Helmet>

      <Container fluid className="p-3">
        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Title className="mb-4 mt-2 fs-2 text-center">
            แก้ไขค่าใช้จ่ายระหว่างทำงาน
          </Card.Title>

          <SearchFilter
            data={searchInput}
            inputField={searchInput}
            searchCallback={search => search ? getDataTable(search) : setTableData([])}
          />
        </Card>

        <Card className="m-1 mb-4 p-4 border-0">
          <Card.Header className="p-3 d-flex justify-content-between align-items-center border-bottom-0 bg-transparent">
            <Card.Title className="mb-0 fs-2">
              รายละเอียดค่าใช้จ่ายระหว่างทำงาน
            </Card.Title>
          </Card.Header>

          <Form noValidate className="pb-4" >
            <TableForm2s
              data={tableData}
              columns={columns}
              // pending={loading}
              editForm={false}
              pagination={false}
              onChangeCallback={(newData) => {
                const array = newData.map(el => ({
                  date: el.date,
                  expenses_desc: el.expenses_desc,
                  expenses_qty: +el.expenses_qty,
                  expenses_unit: el.expenses_unit,
                  expenses_price: +el.expenses_price,
                  expenses_total_price: el.expenses_price * el.expenses_qty,
                  expenses_price_unit: el.expenses_price_unit,
                  remark: el.remark,
                }));
                setTableData(array);
                setDataModal(array[0]);
              }}
            />
          </Form>

          <Row className="justify-content-end mt-3">
            <Col className="col-auto">
              <Button
                type="submit"
                variant="success"
                className="me-2 px-5 py-2 text-dark rounded-pill"
                onClick={() => setShowModal(!showModal)}
              >
                บันทึกข้อมูล
              </Button>
              <ConfirmModal
                show={showModal}
                data={dataModal}
                content={"save"}
                onSubmitCallback={handleSubmit}
              />
              <Button
                variant="outline-secondary"
                className="px-5 py-2 text-dark border-dark border-opacity-50 rounded-pill"
                onClick={() =>
                  navigate("/service_work/expenses")
                }
              >
                ย้อนกลับ
              </Button>
            </Col>
          </Row>
        </Card>

      </Container>
    </>
  );
}
